var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgChevronDown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29289 8.28979C4.68342 7.9034 5.31658 7.9034 5.70711 8.28979L11.5 14.0212L17.2929 8.28978C17.6834 7.9034 18.3166 7.9034 18.7071 8.28978C19.0976 8.67616 19.0976 9.30261 18.7071 9.68899L12.9142 15.4204C12.1332 16.1932 10.8668 16.1932 10.0858 15.4204L4.29289 9.689C3.90237 9.30261 3.90237 8.67617 4.29289 8.28979Z",
    fill: "#545454"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChevronDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ChevronDown.7839429d.svg";
export { ForwardRef as ReactComponent };